import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./buy.module.scss";
const BuyButton = ({ onClick }) => {
    return (_jsx("button", Object.assign({ className: styles.buttonContainer, onClick: onClick }, { children: "Buy" })));
};
export default BuyButton;
